import { get } from "lodash";
import moment from "moment";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import italianMessages from "ra-language-italian";
import portugueseMessages from "ra-language-pt-br";
import spanishMessages from "ra-language-spanish";
import { resolveBrowserLocale } from "react-admin";

const defaultMessages = {
	en: englishMessages,
	it: italianMessages,
	es: spanishMessages,
	pt: portugueseMessages,
};

const getLocale = (languages, locale) => {
	const defaultLocale = "en";
	const language = get(languages, locale, languages[defaultLocale]);
	const defaultMessage = get(
		defaultMessages,
		locale,
		defaultMessages[defaultLocale]
	);
	return {
		...defaultMessage,
		...language,
	};
};

const i18nProvider = (languages) =>
	polyglotI18nProvider((locale) => {
		if (process.env.NODE_ENV !== "production") {
			localStorage.setItem("locale", locale);
		}
		moment.locale(locale);
		return getLocale(languages, locale);
	}, resolveBrowserLocale());

export default i18nProvider;
